export const useShowLandingPageExperiment = () => {
  const showNewLandingPageExperiment = false;

  return {
    showLandingPagesHeroRedesign: showNewLandingPageExperiment,
  };
};
